import request from '@/utils/request';

// 农产品加工项目-申请
export function agrProductAddApply(data) {
  return request({
    url: '/ps/agriproduct/project/application/add',
    method: 'POST',
    data,
  });
}

// 农产品加工项目-详情
export function getAgrProductDetail(id) {
  return request({
    url: '/ps/agriproduct/project/application/detail',
    method: 'GET',
    params: { id, type: 1 },
  });
}

// 农产品加工项目-更新数据
export function updateAgrProduct(data) {
  return request({
    url: '/ps/agriproduct/project/application/edit',
    method: 'POST',
    data,
  });
}

// 千亿农业优势产业项目-申报
export function billionProductAddApply(data) {
  return request({
    url: '/ps/billion/project/application/add',
    method: 'POST',
    data,
  });
}

// 千亿农业优势产业项目-详情
export function getBillionProductDetail(id) {
  return request({
    url: '/ps/billion/project/application/detail',
    method: 'GET',
    params: { id, type: 1 },
  });
}

// 千亿农业优势产业项目-更新数据
export function updateBillionProduct(data) {
  return request({
    url: '/ps/billion/project/application/edit',
    method: 'POST',
    data,
  });
}

// 千亿农业优势产业项目-项目名称
export function getProjectName(params) {
  return request({
    url: '/ps/billion/project/application/project/init',
    method: 'GET',
    params,
  });
}

// 农产品-项目名称
export function getAgrProjectName(params) {
  return request({
    url: '/ps/agriproduct/project/application/project/init',
    method: 'GET',
    params,
  });
}

// 千亿农业优势产业项目-所属产业链
export function getIndustryOption() {
  return request({
    url: '/ps/billion/project/application/industry/init',
    method: 'GET',
  });
}

// 我的项目-列表
export function getMyProjectList(data) {
  return request({
    url: '/ps/common/my/project',
    method: 'POST',
    data,
  });
}
// 农产品发布数据回显
export function getAgrProductRelease() {
  return request({
    url: '/ps/agriproduct/project/application/special/year',
    method: 'GET',
  });
}

// 获取-建设类容
export function getXmddSpecialContentData(id) {
  return request({
    url: '/ps/agriproduct/project/application/agriproductContent',
    method: 'GET',
    params: { id },
  });
}
